import React, { useEffect, useRef, useState, lazy } from "react";
import './contactus.css'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { useLocation, useSearchParams } from "react-router-dom";
import CaptchaControl from "../dynamic-form/commonComponent/CaptchaControl";
import {
  getDatasContactService,
  handlePostDataService,
} from "../../API/contactusApi";
import Spinner from "../../components/Spinner";
import { BsClock } from "react-icons/bs";
import  {formatTime}  from "../../helper/Formatter";

const ContactUs = () => {
  let ID = localStorage.getItem("branchid");

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [backgroundColor, setbackGroundColor] = useState("");
  const [disableBtn, setButton] = useState(true);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [foregroundColor, setForeGroundColor] = useState("");
  const [transprantBackgroundstyle, setTransparentbackgroundcolor] =
    useState(true);
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const validateForm = (data) => {
    const errors = {};
    if (!data.fullname) errors.fullname = "Fullname is required";
    if (!data.mobile) {
      errors.mobile = "Contact number is required";
    // } else if (data.mobile.length < 10) {
    //   errors.mobile = "Contact number is not in a valid format";
    // }
    }
    if (!data.primaryemail) {
      errors.primaryemail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.primaryemail)) {
      errors.primaryemail = "Email is not valid";
    }
    if (!data.subject) errors.subject = "Subject is required";
    if (!data.remark) errors.remark = "Message is required";
    return errors;
  };

  const [contactuslist, setcontactuslist] = useState({});
  const [loader, setLoader] = useState(true);
  const [daystime, setDaystime] = useState([]);
  const alphaNums = [];

  for (let i = 65; i <= 90; i++) {
    alphaNums.push(String.fromCharCode(i));
  }

  // Add lowercase letters
  for (let i = 97; i <= 122; i++) {
    alphaNums.push(String.fromCharCode(i));
  }

  // Add numbers
  for (let i = 0; i <= 9; i++) {
    alphaNums.push(i.toString());
  }

  const [emptyArr, setemptyArr] = useState([]);
  const shouldLog = useRef(true);
  useEffect(() => {
    const cdata = async () => {
      let daysList,
        setdaylist = [];
      daysList = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      setLoader(true);
      if (shouldLog.current) {
        shouldLog.current = false;
        const res = await getDatasContactService();

        daysList.map((item, i) => {
          if (res?.data?.workinghours?.days?.includes(item)) {
            setdaylist.push({
              day: item,
              workinghours:
                res.data.workinghours.starttime +
                "-" +
                res.data.workinghours.endtime,
            });
          } else {
            setdaylist.push({
              day: item,
              workinghours: "Closed",
            });
          }
        });
        setDaystime(setdaylist);
        setcontactuslist(res.data);
        setLoader(false);
        SetColor();
      }
    };
    cdata();
    return () => {
      setcontactuslist({});
      setLoader(false);
    };
  }, []);
  const SetColor = () => {
    setbackGroundColor(searchParams.get("backgroundColor"));
    setForeGroundColor(searchParams.get("foregroundColor"));
    setTransparentbackgroundcolor(
      searchParams.get("foregroundColor") !== "" && false
    );
  };

  function handleRefreshCaptcha() {
    let refreshArr = [];
    for (let j = 1; j <= 7; j++) {
      refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    setemptyArr(refreshArr);
    const captchaInput = document.getElementById("captchaInput");
    if (captchaInput) {
      captchaInput.value = "";
    }
  }

  const formsubmit = async (data) => {
    const validationErrors = validateForm(data);
    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => toast.warn(error), {
        autoClose: 1000,
      });
      return;
    }

    const captchaInput = document.getElementById("captchaInput");
    if (!captchaInput.value) {
      toast.error("Enter your captcha", { autoClose: 1000 });
    } else {
      try {
        setButton(false); // Disable the button on form submit
        const postdata = await handlePostDataService(data);
        if (postdata.status === 200) {
          toast.success("Thank you for reaching out!", { autoClose: 1000 });
          setButton(!disableBtn);
          reset({
            fullname: "",
            mobile: "", // Clear the PhoneInput value
            primaryemail: "",
            subject: "",
            remark: "",
          });

          setcontactuslist((prev) => ({ ...prev, mobile: "" })); // Explicitly clear mobile
          setCaptchaValid(false);
          captchaInput.value = "";
          handleRefreshCaptcha();
        }
      } catch (error) {
        console.error("error::: ", error);
      }

      setButton(false);
    }
  };

  const handleCaptchaValidation = (flg) => {
    setCaptchaValid(flg);
    if (flg) {
      setButton(true);
    } else {
      setButton(false);
    }
  };
  return (
    <>
      {loader && <Spinner />}

      {contactuslist && Object.keys(contactuslist)?.length > 0 ? (
        <section className="common-block">
          <div className="container p-0">
            <ToastContainer />
            <div className="row mb-5">
              {!location.pathname.split("/").includes("iframe") && (
                <div className="col-md-6 col-lg-6 mb-4 mb-md-0">
                  <h3 className="card-title mb-4"> Contact Us </h3>
                  <div className="mb-4">
                    <div className="mb-4">
                      <h5 className="mb-3">{contactuslist.branchname}</h5>
                      <div className="mb-2 d-flex align-items-start">
                        <img
                          src="/images/map-icon.svg"
                          alt=""
                          className="mr-2 mt-1"
                        />
                        &nbsp;&nbsp;
                        {contactuslist.property?.address !== undefined
                          ? contactuslist.property?.address + ","
                          : ""}
                        &nbsp;
                        {contactuslist.property?.country !== undefined
                          ? contactuslist.property?.country
                          : "."}
                        &nbsp;
                        {contactuslist.property?.pincode !== undefined
                          ? contactuslist.property?.pincode
                          : "."}
                        &nbsp;
                      </div>
                      {contactuslist.property?.mobile1 && (
                        <div className="mb-2 d-flex align-items-center">
                          <img
                            src="/images/telephone-icon.svg"
                            alt=""
                            className="mr-2"
                          />
                          &nbsp;&nbsp;
                          {contactuslist.property?.mobile1 !== undefined
                            ? contactuslist.property?.mobile1
                            : ""}
                        </div>
                      )}

                      {contactuslist?.property?.primaryemail && (
                        <div className="mb-2 d-flex align-items-center">
                          <img
                            src="/images/email-icon.svg"
                            alt=""
                            className="mr-2"
                          />
                          &nbsp;&nbsp;
                          <a href={"mailto:" + contactuslist.property?.from}>
                            {contactuslist.property?.primaryemail !== undefined
                              ? contactuslist.property?.from
                              : ""}
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-3">
                        <BsClock className="w-5 h-5" />
                        &nbsp;&nbsp;Opening Hours
                      </h6>

                      <div className="max-w-md mx-auto bg-white">
                        <table className="table table-borderless">
                          <tbody>
                            {contactuslist?.workinghours?.customedays?.map(
                              ({ day, starttime, endtime }) => (
                                <tr key={day}>
                                  <td
                                    className="text-muted"
                                    style={{ width: "35%" }}
                                  >
                                    {day}
                                  </td>
                                  <td className="text-start text-muted">
                                    {starttime && endtime
                                      ? `${formatTime(
                                          starttime
                                        )} - ${formatTime(endtime)}`
                                      : "Closed"}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* <div className="contact-time-main">
                        <img
                          src="/images/time-icon.svg"
                          alt=""
                          className="contact-time-icon"
                        />
                        <table>
                          <tbody>
                            {daystime !== undefined
                              ? daystime.map((item, i) => {
                                  return (
                                    <tr key={i}>
                                      <td style={{ width: 150 }}>
                                        {item.day + ","}
                                      </td>
                                      <td>{item.workinghours}</td>
                                    </tr>
                                  );
                                })
                              : ""}
                          </tbody>
                        </table>
                      </div> */}
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-6 col-lg-6">
                <div
                  className={`white-box ${
                    transprantBackgroundstyle ? "background-transparent" : ""
                  } p-1 p-xl-4`}
                  style={{
                    backgroundColor:
                      foregroundColor !== "" ? "#" + foregroundColor : "",
                  }}
                >
                  <form
                    className="membroz-form wpcf7-form"
                    onSubmit={handleSubmit(formsubmit)}
                  >
                    <h5 className="mb-3">Happy to Help You</h5>
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <input
                            type="text"
                            placeholder="Full name"
                            className="form-control"
                            {...register("fullname")}
                          />
                          <span className="errorMessage">
                            {errors.fullname?.message}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <PhoneInput
                           disableDropdown={true}
                           onlyCountries={["us"]}
                            country={"us"}
                            placeholder="Contact number"
                            inputClass="form-control extra_number"
                            value={contactuslist.mobile || ""}
                            onChange={(value) => {
                              reset({ ...contactuslist, mobile: value });
                            }}
                          />
                          <span className="errorMessage">
                            {errors.mobile?.message}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <input
                            type="email"
                            placeholder="Email"
                            className="form-control"
                            {...register("primaryemail")}
                          />
                          <span className="errorMessage">
                            {errors.primaryemail?.message}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <input
                            type="text"
                            placeholder="Subject"
                            className="form-control"
                            {...register("subject")}
                          />
                          <span className="errorMessage">
                            {errors.subject?.message}
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <textarea
                            className="form-control"
                            placeholder="Message"
                            rows="5"
                            {...register("remark")}
                          ></textarea>
                          <span className="errorMessage">
                            {errors.remark?.message}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <CaptchaControl
                            newArr={emptyArr}
                            onClick={handleRefreshCaptcha}
                            label={"Enter captcha code"}
                            capchaCorrectValue={handleCaptchaValidation}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group mb-2">
                          <button
                            type="submit"
                            disabled={
                              !disableBtn ||
                              Object.keys(errors).length > 0 ||
                              !captchaValid
                            }
                            className="wpcf7-form-control has-spinner wpcf7-submit btn btn-primary btn-lg"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="container mt-3" style={{ textAlign: "center" }}>
          No Data Found
        </div>
      )}
    </>
  );
};
export default ContactUs;
